module.exports = __webpack_public_path__ + "img/3x.b761984.jpg";